import { t } from 'ttag'

export const getColumns = () => [
  { header: t`name`, accessorKey: 'name' },
  { header: t`access`, accessorKey: 'role' },
  { header: t`email`, accessorKey: 'email' },
  { header: t`joined`, accessorKey: 'date_joined' },
]
